import * as React from 'react';
import { Button, ButtonToolbar, Modal, Nav, NavItem, Tab, Table } from 'react-bootstrap';
import { Translate } from '../../../shared/LanguageService';
import ImageUpload from './ImageUpload';
import { IAttachment } from '../../../features/orders/view/basicorderinfo/Types';

class ImageModal extends React.Component<any, any> {
    constructor(props: any, context: any) {
        super(props, context);

        this.state = {};
        this.save = this.save.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.onUploadCompleted = this.onUploadCompleted.bind(this);
    }

    closeModal() {
        this.props.onClose();
    }

    save() {
        this.setState({ saving: true });
    }

    onUploadCompleted(file: any) {
        let response = file.xhr.response;

        if (response) {
            let files = JSON.parse(response);

            const uploadedFile: IAttachment = files[0];
            this.onSelect(uploadedFile.reference, file.width, file.height);
            this.props.onImageUploaded(uploadedFile);
        }
    }

    onSelect(reference: any, width?: any, height?: any) {
        this.props.onClose(reference, width, height);
    }

    render() {
        const { apiUrl } = window.appConfig;

        return (
            <Modal show={true} onHide={this.closeModal} bsSize="large">
                <Modal.Header closeButton>
                    <Modal.Title>{Translate('editor/image-modal/title')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Tab.Container defaultActiveKey={1} id="uncontrolled-tab">
                        <div>
                            <Nav>
                                <NavItem eventKey={1}>
                                    {Translate('editor/image-modal/new-file')}
                                </NavItem>
                                <NavItem eventKey={2}>
                                    {Translate('editor/image-modal/files-list')}
                                </NavItem>
                            </Nav>
                            <Tab.Content>
                                <Tab.Pane eventKey={1}>
                                    <fieldset>
                                        <legend>{Translate('editor/image-modal/new-file')}</legend>
                                        <ImageUpload
                                            upload={this.state.saving}
                                            onUploadCompleted={this.onUploadCompleted}
                                        />
                                    </fieldset>
                                </Tab.Pane>
                                <Tab.Pane eventKey={2}>
                                    <fieldset>
                                        <legend>
                                            {Translate('editor/image-modal/files-list')}
                                        </legend>
                                        <Table hover>
                                            <thead>
                                                <tr>
                                                    <th>
                                                        {Translate(
                                                            'editor/image-modal/image-list/header/filename'
                                                        )}
                                                    </th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.props.files.length === 0 && (
                                                    <tr>
                                                        <td>
                                                            {Translate(
                                                                'editor/image-modal/image-list/no-files-yet'
                                                            )}
                                                        </td>
                                                    </tr>
                                                )}
                                                {this.props.files.map((file) => (
                                                    <tr key={file.reference}>
                                                        <td>
                                                            <img
                                                                src={`${apiUrl}/file/${file.reference}`}
                                                                width="50px"
                                                                height="50px"
                                                            />
                                                            {file.filename}
                                                        </td>
                                                        <td className="tools">
                                                            <ButtonToolbar className="pull-right btn-group-sm">
                                                                {this.props.asAttachment ? (
                                                                    <Button
                                                                        onClick={() =>
                                                                            this.props.onDelete(
                                                                                file.id
                                                                            )
                                                                        }
                                                                        bsStyle="danger"
                                                                    >
                                                                        <i className="material-icons">
                                                                            delete
                                                                        </i>{' '}
                                                                        {Translate('delete')}
                                                                    </Button>
                                                                ) : (
                                                                    <Button
                                                                        onClick={() =>
                                                                            this.onSelect(
                                                                                file.reference
                                                                            )
                                                                        }
                                                                        bsStyle="primary"
                                                                    >
                                                                        <i className="material-icons">
                                                                            photo
                                                                        </i>{' '}
                                                                        {Translate(
                                                                            'editor/image-modal/image-list/button-select'
                                                                        )}
                                                                    </Button>
                                                                )}
                                                            </ButtonToolbar>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>
                                    </fieldset>
                                </Tab.Pane>
                            </Tab.Content>
                        </div>
                    </Tab.Container>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={this.closeModal}>
                        {Translate('editor/image-modal/footer/button-label/close')}
                    </Button>
                    <Button disabled={this.state.saving} bsStyle="primary" onClick={this.save}>
                        {Translate('editor/image-modal/footer/button-label/save')}
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default ImageModal;
